<section class="login-blk">
    <div class="input-fields">
        <div class="text-center">
            <img src="../../../../assets/icons/icon-72x72.png">
        </div>
        <h1 class="title mt-2">Login</h1>
        <h1 class="titles mb-4">Enter the login details of your store</h1>
        <div class="barista-card-blk mb-4" *ngIf="bristaMessage">
            <div class="barista-bg bg-clr">
                <div class="row align-items-center content-blk">
                    <div class="col text-white content">
                         <h5>{{bristaMessage.baristaTitle}}</h5>
                        <p class="m-0">{{bristaMessage.baristaContent}}</p>
                    </div>
                </div>
            </div>
        </div>
        <form [formGroup]="loginFormGroup" id="loginForm" (submit)="userLogin()"
            #loginForm="ngForm">
             <div class="inputs mb-1em">
                <label class="label-text">USERNAME</label>
                <mat-form-field floatLabel="never">
                    <input matInput id="username_input" placeholder="Enter Email ID or Mobile Number" appearance="none"
                        formControlName="emailOrMobile" autocomplete=”off” maxlength="320" (keydown.space)="$event.preventDefault()">
                    <mat-error *ngIf="loginFormGroup.controls['emailOrMobile'].hasError('required')">
                        Please enter value
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="inputs m-0">
                <label class="label-text">PASSWORD</label>
                <mat-form-field floatLabel="never">
                    <input matInput placeholder="Enter Password" formControlName="password" type="password"
                        minLength="8" maxlength="50" (keydown.space)="$event.preventDefault()">
                    <mat-error *ngIf="loginFormGroup.controls['password'].hasError('required')">
                        Please enter value
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="text-center button-block" [ngClass]="{'shimmer-loader-button': isClicked}">
                <button type="submit" class="btn-xlg-rounded custom-btn btn-green full-width-btn space"
                    [ngStyle]="{'opacity': loginFormGroup.invalid ? '0.6' : '1' }"
                    [disabled]='loginFormGroup.invalid' [ngClass]="{'br animate-button-white' : isClicked}">Login</button>
            </div>
        </form>
    </div>
</section>
